
import { VListItemAvatar } from "vuetify/lib";

export default VListItemAvatar.extend({});
